// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#react-select-3-placeholder {
  color: #A7B2CD;
  font-weight: normal;
}

.css-13cymwt-control {
  border-radius: 0.5rem !important;
  border: 1px solid #ced4da !important;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

.css-t3ipsp-control {
  border-color: #80bdff !important;
  outline: 0 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.companies-list tr th {
  font-weight: 500;
}
.companies-list tr {
  cursor: pointer;
  border-bottom: 1px solid #e4e7f0;
}
.companies-list tr td {
  color: #222735;
}
.companies-list tr:last-child {
  border-bottom: 0;
}
.companies-list th,
.companies-list td {
  font-size: 14px;
  padding: 1rem 0.5rem;
}

.company-details {
  display: flex;
  align-items: stretch;
  flex-direction: column;
}
.company-details th {
  color: #636A7D;
  font-weight: 500;
  width: 50%;
  padding: 6px 0;
}
.company-details.contact th {
  width: 36%;
}
.company-details img {
  vertical-align: bottom;
  margin-left: -4px;
}

select:required:invalid,
#react-select-7-placeholder {
  color: #A7B2CD !important;
}

.ubo-form.disabled .btn-ghost {
  border-color: #A7B2CD;
  color: #A7B2CD;
  pointer-events: none;
  cursor: not-allowed;
}
.ubo-form.disabled .btn-with-icon {
  pointer-events: none;
  background: #A7B2CD;
  border-color: #A7B2CD;
}

.accordion.active h4 {
  color: #110133;
}
.accordion {
  margin-bottom: 16px;
  pointer-events: all;
}
.accordion .accordion-heading {
  cursor: pointer;
}
.accordion .accordion-content {
  display: none;
}
.accordion .accordion-content-invisible {
  display: block;
  opacity: 0;
  position: absolute;
  top: 100px;
  width: calc(100% - 3rem);
}
.accordion.loading {
  pointer-events: none;
}
.accordion.loading .accordion-content {
  display: none !important;
}
.accordion.loading .loading-icon {
  display: block;
}
.accordion.loading h4 {
  color: #A7B2CD;
}
.accordion.loading .chevron-icon {
  opacity: 0.6;
}
.accordion .loading-icon {
  display: none;
}
.accordion .chevron-icon {
  transition: all 0.2s ease;
}
.accordion.active .accordion-content {
  margin-top: 16px;
  border-top: 1px solid #E4E7F0;
  padding-top: 16px;
  display: block;
}
.accordion.active .accordion-content-invisible {
  opacity: 1;
  position: initial;
  width: 100%;
}
.accordion.active .chevron-icon {
  transform: rotate(-180deg);
}
.accordion .btn-status-complete {
  color: #11BC97;
  border: 1px solid #11BC97;
  padding: 4px 18px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}

.accordion-table {
  width: 100%;
}
.accordion-table.risk-table th.table-header {
  font-size: 1rem;
  color: #110133;
}
.accordion-table.risk-table td {
  vertical-align: top;
}
.accordion-table.risk-table .no-text-wrap {
  text-wrap: nowrap;
}
.accordion-table.sm-th-md-td thead tr {
  border-bottom: 0;
}
.accordion-table.sm-th-md-td th {
  font-size: 13px;
  padding-bottom: 24px;
}
.accordion-table.sm-th-md-td td {
  font-size: 14px;
}
.accordion-table tr {
  border-bottom: 1px solid #E4E7F0;
}
.accordion-table tr.disabled td {
  color: #A7B2CD;
}
.accordion-table th {
  color: #636A7D;
  font-weight: 500;
  padding: 12px;
  line-height: 22px;
}
.accordion-table td {
  color: #110133;
  padding: 12px;
}
.accordion-table td.no-text-wrap {
  text-wrap: nowrap;
}
.accordion-table td.full-width {
  width: 100%;
}

.rb-tabs .rb-tabs-items {
  border-bottom: 0 !important;
}
.rb-tabs .rb-tabs-item {
  border-bottom: 2px solid transparent;
  padding: 8px 0 !important;
  margin-right: 40px;
  color: #636A7D;
  font-weight: 600;
}
.rb-tabs .rb-tabs-item.active {
  border-color: #11BC97;
  color: #11BC97;
  font-weight: 600 !important;
}
.rb-tabs.green .rb-tabs-item.active {
  border-color: #11BC97;
  color: #11BC97;
}
.rb-tabs.pink .rb-tabs-item.active {
  border-color: #E66A8B;
  color: #E66A8B;
}
.rb-tabs .rb-tabs-active-item {
  display: none;
}

.accordion .batchJobsListing li .company {
  flex: 0 0 240px;
}

button:disabled {
  background: #A7B2CD;
  border-color: #A7B2CD !important;
  color: white;
}

button:hover:disabled {
  background: #A7B2CD;
  border-color: #A7B2CD !important;
  color: white;
}

.react-tabs__tab-list {
  display: flex;
}

.react-tabs__tab {
  border-bottom: 2px solid transparent;
  padding: 8px 0 !important;
  margin-right: 40px;
  color: #636a7d;
  font-weight: 600;
  outline: none;
  cursor: pointer;
}

.react-tabs__tab.react-tabs__tab--selected {
  border-color: #11bc97;
  color: #11bc97;
}

.relevent-docs tr th:first-child,
.relevent-docs tr td:first-child {
  width: 210px;
  text-align: left;
}
.relevent-docs tr th,
.relevent-docs tr td {
  text-align: center;
}
.relevent-docs tr th:nth-of-type(6),
.relevent-docs tr td:nth-of-type(6) {
  text-align: left;
}
.relevent-docs tr th:last-child,
.relevent-docs tr td:last-child {
  position: relative;
}
.relevent-docs tr th:last-child svg,
.relevent-docs tr th:last-child img,
.relevent-docs tr td:last-child svg,
.relevent-docs tr td:last-child img {
  cursor: pointer;
}
.relevent-docs .chip {
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  border-radius: 4px;
  display: inline-block;
  background-color: #E4E7F0;
}
.relevent-docs .chip.status-pending {
  background-color: #e4f5fc;
  color: #0090c1;
}
.relevent-docs .chip.status-complete {
  background-color: #e7f8f5;
  color: #11bc97;
}
.relevent-docs .chip.status-error {
  background-color: #feecf1;
  color: #e66a8b;
}
.relevent-docs .hasError {
  display: inline-block;
}
.relevent-docs .hasError:hover .relevantDoc-tooltip {
  display: block;
}
.relevent-docs .hasError .relevantDoc-tooltip {
  position: absolute;
  right: 48px;
  bottom: 48px;
  width: 262px;
  text-align: initial;
  background-color: rgba(34, 39, 53, 0.8392156863);
  color: #ffffff;
  padding: 12px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 22px;
  z-index: 999;
  display: none;
}
.relevent-docs .hasError .relevantDoc-tooltip ul {
  margin: 0;
  padding-left: 16px;
}
.relevent-docs .hasError .relevantDoc-tooltip ul li {
  list-style-type: decimal;
}

.confirm-popup thead th {
  padding-bottom: 0 !important;
}

.ReactModal__Overlay {
  background-color: rgba(34, 39, 53, 0.5490196078) !important;
}

.ReactModal__Content--after-open {
  border-radius: 8px !important;
}

.cr-animated-spinner {
  width: 40px;
}

path.link {
  fill: none;
  stroke: #666;
  stroke-width: 1.5px;
}

marker#licensing {
  fill: green;
}

path.link.licensing {
  stroke: green;
}

path.link.resolved {
  stroke-dasharray: 0, 2 1;
}

circle {
  fill: #ccc;
  stroke: #333;
  stroke-width: 1.5px;
}

text {
  font: 10px sans-serif;
  pointer-events: none;
}

text.shadow {
  stroke: #fff;
  stroke-width: 3px;
  stroke-opacity: 0.8;
}

.text-and-loader-container {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/companyReport.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,cCYkB;EDXlB,mBAAA;AADF;;AAIA;EACE,gCAAA;EACA,oCAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,gCAAA;EACA,qBAAA;EACA,2DAAA;AADF;;AAKE;EACE,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,gCAAA;AAHJ;AAKI;EACE,cAAA;AAHN;AAOE;EACE,gBAAA;AALJ;AAQE;;EAEE,eAAA;EACA,oBAAA;AANJ;;AAUA;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;AAPF;AASE;EACE,cCrCkB;EDsClB,gBAAA;EACA,UAAA;EACA,cAAA;AAPJ;AAWI;EACE,UAAA;AATN;AAaE;EACE,sBAAA;EACA,iBAAA;AAXJ;;AAeA;;EAEE,yBAAA;AAZF;;AAgBE;EACE,qBC/DgB;EDgEhB,cChEgB;EDiEhB,oBAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,oBAAA;EACA,mBCvEgB;EDwEhB,qBCxEgB;AD0DpB;;AAmBE;EACE,cCjFY;ADiEhB;AAcA;EAKE,mBAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,eAAA;AAhBJ;AAmBE;EACE,aAAA;AAjBJ;AAmBI;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;AAjBN;AAqBE;EACE,oBAAA;AAnBJ;AAqBI;EACE,wBAAA;AAnBN;AAsBI;EACE,cAAA;AApBN;AAuBI;EACE,cChHc;AD2FpB;AAwBI;EACE,YAAA;AAtBN;AA0BE;EACE,aAAA;AAxBJ;AA2BE;EACE,yBAAA;AAzBJ;AA6BI;EACE,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;AA3BN;AA6BM;EACE,UAAA;EACA,iBAAA;EACA,WAAA;AA3BR;AA+BI;EACE,0BAAA;AA7BN;AAiCE;EACE,cCjKS;EDkKT,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA/BJ;;AAmCA;EACE,WAAA;AAhCF;AAoCM;EACE,eAAA;EACA,cCvKQ;ADqIhB;AAsCI;EACE,mBAAA;AApCN;AAuCI;EACE,iBAAA;AArCN;AA0CI;EACE,gBAAA;AAxCN;AA2CI;EACE,eAAA;EACA,oBAAA;AAzCN;AA4CI;EACE,eAAA;AA1CN;AA8CE;EACE,gCAAA;AA5CJ;AA8CI;EACE,cAAA;AA5CN;AAgDE;EACE,cCxMkB;EDyMlB,gBAAA;EACA,aAAA;EACA,iBAAA;AA9CJ;AAiDE;EACE,cCnNY;EDoNZ,aAAA;AA/CJ;AAiDI;EACE,iBAAA;AA/CN;AAkDI;EACE,WAAA;AAhDN;;AAsDE;EACE,2BAAA;AAnDJ;AAsDE;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCrOkB;EDsOlB,gBAAA;AApDJ;AAuDE;EACE,qBCxPS;EDyPT,cCzPS;ED0PT,2BAAA;AArDJ;AAyDI;EACE,qBC/PO;EDgQP,cChQO;ADyMb;AA4DI;EACE,qBClQM;EDmQN,cCnQM;ADyMZ;AA8DE;EACE,aAAA;AA5DJ;;AAiEE;EACE,eAAA;AA9DJ;;AAkEA;EACE,mBC1QkB;ED2QlB,gCAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,mBChRkB;EDiRlB,gCAAA;EACA,YAAA;AA/DF;;AAkEA;EACE,aAAA;AA/DF;;AAkEA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,qBAAA;EACA,cAAA;AA/DF;;AAoEI;;EAEE,YAAA;EACA,gBAAA;AAjEN;AAoEI;;EAEE,kBAAA;AAlEN;AAqEI;;EAEE,gBAAA;AAnEN;AAsEI;;EAEE,kBAAA;AApEN;AAsEM;;;;EAEE,eAAA;AAlER;AAuEE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBC7Uc;ADwQlB;AAuEI;EACE,yBAAA;EACA,cAAA;AArEN;AAwEI;EACE,yBAAA;EACA,cAAA;AAtEN;AAyEI;EACE,yBAAA;EACA,cAAA;AAvEN;AA2EE;EACE,qBAAA;AAzEJ;AA2EI;EACE,cAAA;AAzEN;AA4EI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;EACA,cC3XQ;ED4XR,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AA1EN;AA4EM;EACE,SAAA;EACA,kBAAA;AA1ER;AA4EQ;EACE,wBAAA;AA1EV;;AAiFA;EACE,4BAAA;AA9EF;;AAiFA;EACE,2DAAA;AA9EF;;AAiFA;EACE,6BAAA;AA9EF;;AAiFA;EACE,WAAA;AA9EF;;AAiFA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AA9EF;;AAiFA;EACE,WAAA;AA9EF;;AAiFA;EACE,aAAA;AA9EF;;AAiFA;EACE,wBAAA;AA9EF;;AAiFA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AA9EF;;AAiFA;EACE,qBAAA;EACA,oBAAA;AA9EF;;AAiFA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AA9EF;;AAiFA;EACE,aAAA;EACA,mBAAA;AA9EF","sourcesContent":["@import './colors';\n\n#react-select-3-placeholder {\n  color: $color-monoDullGrey;\n  font-weight: normal;\n}\n\n.css-13cymwt-control {\n  border-radius: 0.5rem !important;\n  border: 1px solid #ced4da !important;\n}\n\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n.css-t3ipsp-control {\n  border-color: #80bdff !important;\n  outline: 0 !important;\n  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%) !important;\n}\n\n.companies-list {\n  tr th {\n    font-weight: 500;\n  }\n\n  tr {\n    cursor: pointer;\n    border-bottom: 1px solid #e4e7f0;\n\n    td {\n      color: #222735;\n    }\n  }\n\n  tr:last-child {\n    border-bottom: 0;\n  }\n\n  th,\n  td {\n    font-size: 14px;\n    padding: 1rem 0.5rem;\n  }\n}\n\n.company-details {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n\n  th {\n    color: $color-monoNormalGrey;\n    font-weight: 500;\n    width: 50%;\n    padding: 6px 0;\n  }\n\n  &.contact {\n    th {\n      width: 36%;\n    }\n  }\n\n  img {\n    vertical-align: bottom;\n    margin-left: -4px;\n  }\n}\n\nselect:required:invalid,\n#react-select-7-placeholder {\n  color: $color-monoDullGrey !important;\n}\n\n.ubo-form.disabled {\n  .btn-ghost {\n    border-color: $color-monoDullGrey;\n    color: $color-monoDullGrey;\n    pointer-events: none;\n    cursor: not-allowed;\n  }\n\n  .btn-with-icon {\n    pointer-events: none;\n    background: $color-monoDullGrey;\n    border-color: $color-monoDullGrey;\n  }\n}\n\n.accordion {\n  &.active h4 {\n    color: $color-darkBlue;\n  }\n\n  margin-bottom: 16px;\n  pointer-events: all;\n\n  .accordion-heading {\n    cursor: pointer;\n  }\n\n  .accordion-content {\n    display: none;\n\n    &-invisible {\n      display: block;\n      opacity: 0;\n      position: absolute;\n      top: 100px;\n      width: calc(100% - 3rem);\n    }\n  }\n\n  &.loading {\n    pointer-events: none;\n\n    .accordion-content {\n      display: none !important;\n    }\n\n    .loading-icon {\n      display: block;\n    }\n\n    h4 {\n      color: $color-monoDullGrey;\n    }\n\n    .chevron-icon {\n      opacity: 0.6;\n    }\n  }\n\n  .loading-icon {\n    display: none;\n  }\n\n  .chevron-icon {\n    transition: all 0.2s ease;\n  }\n\n  &.active {\n    .accordion-content {\n      margin-top: 16px;\n      border-top: 1px solid $color-normalGrey;\n      padding-top: 16px;\n      display: block;\n\n      &-invisible {\n        opacity: 1;\n        position: initial;\n        width: 100%;\n      }\n    }\n\n    .chevron-icon {\n      transform: rotate(-180deg);\n    }\n  }\n\n  .btn-status-complete {\n    color: $color-green;\n    border: 1px solid $color-green;\n    padding: 4px 18px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n  }\n}\n\n.accordion-table {\n  width: 100%;\n\n  &.risk-table {\n    th {\n      &.table-header {\n        font-size: 1rem;\n        color: $color-darkBlue;\n      }\n    }\n    \n    td {\n      vertical-align: top;\n    }\n\n    .no-text-wrap {\n      text-wrap: nowrap;\n    }\n  }\n\n  &.sm-th-md-td {\n    thead tr {\n      border-bottom: 0;\n    }\n\n    th {\n      font-size: 13px;\n      padding-bottom: 24px;\n    }\n\n    td {\n      font-size: 14px;\n    }\n  }\n\n  tr {\n    border-bottom: 1px solid $color-normalGrey;\n\n    &.disabled td {\n      color: #A7B2CD;\n    }\n  }\n\n  th {\n    color: $color-monoNormalGrey;\n    font-weight: 500;\n    padding: 12px;\n    line-height: 22px;\n  }\n\n  td {\n    color: $color-darkBlue;\n    padding: 12px;\n\n    &.no-text-wrap {\n      text-wrap: nowrap;\n    }\n\n    &.full-width {\n      width: 100%;\n    }\n  }\n}\n\n.rb-tabs {\n  .rb-tabs-items {\n    border-bottom: 0 !important;\n  }\n\n  .rb-tabs-item {\n    border-bottom: 2px solid transparent;\n    padding: 8px 0 !important;\n    margin-right: 40px;\n    color: $color-monoNormalGrey;\n    font-weight: 600;\n  }\n\n  .rb-tabs-item.active {\n    border-color: $color-green;\n    color: $color-green;\n    font-weight: 600 !important;\n  }\n\n  &.green {\n    .rb-tabs-item.active {\n      border-color: $color-green;\n      color: $color-green;\n    }\n  }\n\n  &.pink {\n    .rb-tabs-item.active {\n      border-color: $color-pink;\n      color: $color-pink;\n    }\n  }\n\n  .rb-tabs-active-item {\n    display: none;\n  }\n}\n\n.accordion {\n  .batchJobsListing li .company {\n    flex: 0 0 240px;\n  }\n}\n\nbutton:disabled {\n  background: $color-monoDullGrey;\n  border-color: $color-monoDullGrey !important;\n  color: white;\n}\n\nbutton:hover:disabled {\n  background: $color-monoDullGrey;\n  border-color: $color-monoDullGrey !important;\n  color: white;\n}\n\n.react-tabs__tab-list {\n  display: flex;\n}\n\n.react-tabs__tab {\n  border-bottom: 2px solid transparent;\n  padding: 8px 0 !important;\n  margin-right: 40px;\n  color: #636a7d;\n  font-weight: 600;\n  outline: none;\n  cursor: pointer;\n}\n\n.react-tabs__tab.react-tabs__tab--selected {\n  border-color: #11bc97;\n  color: #11bc97;\n}\n\n.relevent-docs {\n  tr {\n    th:first-child,\n    td:first-child {\n      width: 210px;\n      text-align: left;\n    }\n\n    th,\n    td {\n      text-align: center;\n    }\n\n    th:nth-of-type(6),\n    td:nth-of-type(6) {\n      text-align: left;\n    }\n\n    th:last-child,\n    td:last-child {\n      position: relative;\n\n      svg,\n      img {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .chip {\n    padding: 4px 8px;\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    border-radius: 4px;\n    display: inline-block;\n    background-color: $color-normalGrey;\n\n    &.status-pending {\n      background-color: #e4f5fc;\n      color: #0090c1;\n    }\n\n    &.status-complete {\n      background-color: #e7f8f5;\n      color: #11bc97;\n    }\n\n    &.status-error {\n      background-color: #feecf1;\n      color: #e66a8b;\n    }\n  }\n\n  .hasError {\n    display: inline-block;\n\n    &:hover .relevantDoc-tooltip {\n      display: block;\n    }\n\n    .relevantDoc-tooltip {\n      position: absolute;\n      right: 48px;\n      bottom: 48px;\n      width: 262px;\n      text-align: initial;\n      background-color: #222735d6;\n      color: $color-white;\n      padding: 12px;\n      border-radius: 8px;\n      font-size: 12px;\n      line-height: 22px;\n      z-index: 999;\n      display: none;\n\n      ul {\n        margin: 0;\n        padding-left: 16px;\n\n        li {\n          list-style-type: decimal;\n        }\n      }\n    }\n  }\n}\n\n.confirm-popup thead th {\n  padding-bottom: 0 !important;\n}\n\n.ReactModal__Overlay {\n  background-color: #2227358c !important;\n}\n\n.ReactModal__Content--after-open {\n  border-radius: 8px !important;\n}\n\n.cr-animated-spinner {\n  width: 40px;\n}\n\npath.link {\n  fill: none;\n  stroke: #666;\n  stroke-width: 1.5px;\n}\n\nmarker#licensing {\n  fill: green;\n}\n\npath.link.licensing {\n  stroke: green;\n}\n\npath.link.resolved {\n  stroke-dasharray: 0, 2 1;\n}\n\ncircle {\n  fill: #ccc;\n  stroke: #333;\n  stroke-width: 1.5px;\n}\n\ntext {\n  font: 10px sans-serif;\n  pointer-events: none;\n}\n\ntext.shadow {\n  stroke: #fff;\n  stroke-width: 3px;\n  stroke-opacity: 0.8;\n}\n\n.text-and-loader-container {\n  display: flex;\n  align-items: center;\n}\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
